import { render, staticRenderFns } from "./LLPOnboardingModal.vue?vue&type=template&id=be4bfd3c&scoped=true&"
import script from "./LLPOnboardingModal.vue?vue&type=script&lang=ts&"
export * from "./LLPOnboardingModal.vue?vue&type=script&lang=ts&"
import style0 from "./LLPOnboardingModal.vue?vue&type=style&index=0&id=be4bfd3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4bfd3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('be4bfd3c', component.options)
    } else {
      api.reload('be4bfd3c', component.options)
    }
    module.hot.accept("./LLPOnboardingModal.vue?vue&type=template&id=be4bfd3c&scoped=true&", function () {
      api.rerender('be4bfd3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/learningPathV2/LLPOnboardingModal.vue"
export default component.exports